export type MediaRecorderConstructor = { new (stream: MediaStream, options?: MediaRecorderOptions): MediaRecorder; isTypeSupported?: (mimeType: string) => boolean }

const MIME_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus']

export function supportedMimeType(mediaRecorder: Pick<MediaRecorderConstructor, 'isTypeSupported'> | undefined = typeof MediaRecorder === 'undefined' ? undefined : MediaRecorder) {
  return MIME_TYPES.find((mimeType) => mediaRecorder?.isTypeSupported?.(mimeType)) || ''
}

export function createRecorder(stream: MediaStream, constructor: MediaRecorderConstructor | undefined = typeof MediaRecorder === 'undefined' ? undefined : MediaRecorder) {
  if (!constructor) throw new Error('当前浏览器不支持录音')
  const mimeType = supportedMimeType(constructor)
  return mimeType ? new constructor(stream, { mimeType }) : new constructor(stream)
}

export function stopStream(stream: MediaStream | null) { stream?.getTracks().forEach((track) => track.stop()) }

export function audioFileName(mimeType: string) { return mimeType.includes('mp4') ? 'recording.m4a' : mimeType.includes('ogg') ? 'recording.ogg' : 'recording.webm' }
